import { ComponentTypes } from "../../../../config/config";
import { SharepointFolderSearchQueryStringBuilder } from "../sharepointFolderSearchQueryStringBuilder";
import { SharepointDocumentLibraryUrlBuilder } from "../sharepointDocumentLibraryUrlBuilder";
import { SharepointSiteSearchUrlBuilder } from "../sharepointSiteSearchUrlBuilder";
import { TeamSearchUrlBuilder } from "../teamSearchUrlBuilder";

export class UrlSearchBuilderFactory {
    static createUrlSearchBuilder(componentType: string, teamWebUrls?: string[], oneDriveWebUrl?: string) {
        switch (componentType) {
            case ComponentTypes.SharePoint:
                return new SharepointSiteSearchUrlBuilder(oneDriveWebUrl);
            case ComponentTypes.SharePointDocuments:
                return new SharepointDocumentLibraryUrlBuilder();
            case ComponentTypes.Teams:
                return new TeamSearchUrlBuilder(teamWebUrls);
            case ComponentTypes.SharePointFolders:
                return new SharepointFolderSearchQueryStringBuilder(oneDriveWebUrl);
            default:
                return new SharepointFolderSearchQueryStringBuilder(oneDriveWebUrl);
        }
    }
}